<template>
	<div>
		<CubePage type="catcheck-view" title="分销收益">
			<div slot="content" class="content">
				<van-sticky :offset-top="44">
					<div class="topbox">
						<div class="topbox-items">
							<div class="topbox-item" v-if="title==1">
								<p>{{listObj.order_count}}</p>
								<p>待审核收益(元)</p>
							</div>
							<div class="border" v-if="title==1"></div>
							<div class="topbox-item">
								<p>{{listObj.receipt_count}}</p>
								<p>已赚取收益(元)</p>
							</div>
						</div>
					</div>
				</van-sticky>
				<div class="conten-box" style="margin: 20px 0;">
					<van-pull-refresh v-model="refreshing" @refresh="onRefresh()">
						<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的订单">
							<template #image>
								<img src="@/assets/img/empty.png" alt="">
							</template>
						</van-empty>
						<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
							:immediate-check="false">
							<div class="orderitem van-clearfix" v-for="(item, idx) in OrderList" :key="idx">
								<van-cell-group style="padding-top: 10px;" v-if="title == 2">
									<van-cell title="金额" :value="'￥'+item.money" />
									<van-cell title="时间：" :value="item.createtime" />
									<van-cell title="备注：" :value="item.memo" />
								</van-cell-group>
								<div v-else>
									<div class="ordertitle">
										<p>订单号：{{item.order_no}}</p>
										<p class="colorred">
											<span> {{item.status_cn}}</span>
										</p>
									</div>
									<van-cell-group>
										<van-cell title="ID" :value="item.id" />
										<van-cell title="支付金额" :value="'￥'+item.pay_price" />
										<van-cell title="收益" :value="'￥'+item.amount" />
										<van-cell title="时间：" :value="item.createtime" />
										<van-cell title="产品名称：" :value="item.goods_name" />
										<van-cell title="产品规格：" :value="item.goods_sku" />
									</van-cell-group>
								</div>
							</div>
						</van-list>
					</van-pull-refresh>

				</div>
			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import CubeView from '@/components/TP/cube-view'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage,
			CubeView
		},
		data() {
			return {
				listObj: {
					order_count: 0,
					receipt_count: 0
				},
				active: 0,
				loading: false,
				finished: false,
				refreshing: false,
				OrderList: [],
				isNoData: false,
				pageIndex: 1,
				pageTotal: 0,
				title: this.$route.query.n
			}
		},
		created() {
			this.get_my_order()
		},
		methods: {
			//下拉刷新
			onRefresh() {
				// 清空列表数据 
				this.finished = false;

				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态

				this.loading = true;
				this.get_my_order();
			},
			// 上滑加载更多
			onLoad() {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.get_my_order();
				}, 100)
			},
			// 获取数据
			get_my_order() {
				var url = "/addons/litestore/api.store/getDownstreamOrderIncome"
				let that = this;
				if (that.title == 2) {
					url = "/addons/litestore/api.distributor/getDownstreamOrderIncome"
				}
				if (that.refreshing) {
					that.clearContainer();
					that.refreshing = false;
				}
				if (that.pageIndex > 1 && that.OrderList.length >= that.pageTotal) {
					that.finished = true;
					return;
				}
				let param = {
					page: that.pageIndex
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						that.loading = false;
						that.isNoData = false
						let resdata = result.data
						//这里对状态 进行分类
						that.pageTotal = resdata.total
						if (that.pageIndex == 1) {
							that.listObj.order_count = resdata.wait_income
							that.listObj.receipt_count = resdata.fulfil_income
						}
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (resdata.rows == null || resdata.rows.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.OrderList = that.OrderList.concat(resdata.rows);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.OrderList.length >= that.pageTotal) {
							that.finished = true;
							return;
						}
					},
				);
			},
			// 初始化数据
			clearContainer() {
				this.loading = false
				this.finished = false
				this.OrderList = []
				this.isNoData = false
				this.pageIndex = 1
				this.pageTotal = 0
			},

			decimalPoint(val) {
				const splitPrice = (val || '0.00').split('.');
				const numb1 = splitPrice[0];
				var numb2 = '00';
				if (splitPrice.length > 1) {
					numb2 = splitPrice[1];
				}
				return `${numb1}.<span style="font-size: 12px; line-height: 12px;">${numb2}</span>`;
			},
		}
	}
</script>
<style lang="less" scoped="scoped">
	/deep/.tabs-nosticky {
		.van-sticky {
			// height: 10px !important;
		}

		.van-tabs__wrap {
			position: relative !important;
		}
	}

	@import url("../../../assets/css/order.css");

	.orderitem {
		margin: 0 10px;
		background-color: #5baa8d;
		box-shadow: 0 0 2px #5baa8d;

		.van-cell {
			padding: 3px 16px;
		}

		.colorred,
		.ordertitle {
			color: #FFFFFF;
		}
	}

	.orderitem+.orderitem {
		margin-top: 10px;
	}

	.topbox {
		background-color: #55aa7f;
		padding: 10px;
		color: #FFFFFF;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;

		.topbox-items {
			height: 120px;
			display: flex;
			justify-content: space-around;
			align-items: center;
			text-align: center;

			p {
				padding: 3px 0;
				font-size: 14px;
			}

			p:first-child {
				font-size: 22px;
				font-weight: 600;
			}

			.border {
				width: 0.5;
				height: 70%;
				border: 0.5px solid #FFFFFF;
				background-color: #FFFFFF;
			}
		}
	}
</style>